"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "treviso-bresciano": {
    "5c85140c": [{
      "hkey": "86553eee",
      "slug": "treviso-bresciano",
      "name": "Treviso Bresciano",
      "primary": true,
      "skipSearch": false
    }],
    "facchetti": [{
      "hkey": "86553eee",
      "slug": "treviso-bresciano",
      "name": "Treviso Bresciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f4336b8": [{
      "hkey": "86553eee",
      "slug": "treviso-bresciano",
      "name": "Treviso Bresciano",
      "primary": true,
      "skipSearch": false
    }],
    "valledrane": [{
      "hkey": "86553eee",
      "slug": "treviso-bresciano",
      "name": "Treviso Bresciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;